import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 16px;
    background: ${theme.v3.colors.brand.snappyBlue[10]};
    border-radius: ${theme.v3.border.radius.lg};
    padding: 16px 8px 16px 24px;
    font-family: ${theme.v3.font.family.brand};
    width: 100%;
    box-sizing: border-box;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-wrap: wrap;
      padding: 20px;
      gap: 12px;
    }
  `}
`;

export const LogoPlaceholder = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  picture {
    display: flex;
    align-items: center;
  }

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    order: 0;
  }
`;

export const LogoImage = styled.img`
  display: block;
  width: 164px;
  height: 77px;
  flex: none;

  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    width: 164px;
    height: 77px;
  }
`;

export const Separator = styled.div`
  ${({ theme }) => css`
    width: 2px;
    height: 20px;
    background: rgba(255, 255, 255, 0.24);
    border-radius: ${theme.v3.border.radius.xl};
    flex-shrink: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    color: ${theme.v3.colors.brand.snappyBlue[98]};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 2;
      width: 100%;
      flex: unset;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.sm};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.spacious};
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    margin: 0;

    strong {
      font-weight: ${theme.v3.font.weights.bold};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.spacious};
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    margin: 0;
    opacity: 0.8;
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.v3.spacing.quarck};
    flex-shrink: 0;

    button {
      border-color: transparent;
      &:hover {
        border-color: transparent;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 3;
      justify-content: center;
    }
  `}
`;

export const CloseAdapter = styled.div`
  ${({ theme }) => css`
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      padding: 0;
      cursor: pointer;
      color: ${theme.v3.colors.brand.snappyBlue[98]};

      svg {
        width: ${theme.v3.icon.size.sm};
        height: ${theme.v3.icon.size.sm};
        fill: ${theme.v3.colors.brand.snappyBlue[98]};
      }
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      order: 1;
      margin-left: auto;
    }
  `}
`;
